import React, { useContext, useState } from "react"
import { storageData } from "services/Services"
import { ReplaceVehicleContext } from "./ReplaceVehicleContext"
import { ownedLeasedFinancedValidator } from "../1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/validator"

export const NewDelete_VehicleContext = React.createContext()

const useModal = () => {
    const [modalTitle, setModalTitle] = useState("");
    const [modalMsg, setModalMsg] = useState("");
    const [showModal, setShowModal] = useState(false);

    const openModal = (title, message) => {
        setModalTitle(title);
        setModalMsg(message);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return {
        modalTitle,
        modalMsg,
        showModal,
        openModal,
        closeModal,
    };
};

export const NewDelete_VehicleContextComp = ({ children }) => {
    const replaceVehicleContext = useContext(ReplaceVehicleContext)
    // Fields for adding a vehicle
    const initialVehicle = {
        componentTracker: "",
        vehicleVIN: "",
        vehicleYear: "",
        vehicleMake: "",
        vehicleModel: "",
        vehicleBody: "",
        requestedCovEffDate: replaceVehicleContext?.replaceVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles[0]?.requestedRemovalEffDate 
        ? replaceVehicleContext?.replaceVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles[0]?.requestedRemovalEffDate
        : replaceVehicleContext.getTodaysDate(true),
        datePurchased: "",
        vehicleOwnedLeasedFinanced: "",
        vehicleIsCoOwned: "",
        vehicleCoOwnerName: "",
        vehicleCoOwnerAddress: "",
        vehicleIsCoLeased: "",
        vehicleLeasingCompany: "",
        vehicleFinanceCompany: "",
        garaged: "",
        vehicleRegistrant: "",
        vehicleIsNJ: "",
        vehicleIsPA: "",
        vehicleUse: "",
        daysDrivenPerWeek: "5 days per week",
        estimatedMileage: "9,001-12,000",
        otherDeductible: "",
        collisionType: "",
        collisionDeductible: "",
        rentalCoverage: "",
        antiTheftSystem: "",//"None",
        vehicleCustomization: "",
        vehicleCommercial: "",
        vehicleCommercialPurposes: "",
        leasedRentToOthers: "",
        vehiclePlowSnow: "",
        wantsOtherThanCollision: "",
        wantsCollision: ""
    }

    const [newVehicle, setNewVehicle] = useState(replaceVehicleContext.replaceVehicleClass.vehicles.vehiclesOnPolicy.newVehicles.length == 0 ?
        initialVehicle :
        replaceVehicleContext.replaceVehicleClass.vehicles.vehiclesOnPolicy.newVehicles[0]
    );

    // Fields for removing a vehicle
    const initialDeleteVehicle = {
        componentTracker: "",
        VIN: "",
        Year: "",
        Make: "",
        Model: "",
        Body: "",
        requestedRemovalEffDate: replaceVehicleContext.getTodaysDate(true),
        garaged: "",
        vehicleRemovalReason: "",
        vehicleRemovalExplanation: ""
    }

    const [deleteVehicle, setDeletedVehicle] = useState(replaceVehicleContext.replaceVehicleClass.vehicles.vehiclesOnPolicy.removedVehicles.length < 1 ?
        initialDeleteVehicle :
        { ...initialDeleteVehicle, ...replaceVehicleContext?.replaceVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles[0] }
    );

    const currResidenceBill = storageData.getItem("currResidenceBill")
    const policyStreetAddress = JSON.parse(currResidenceBill).address1
    const modal = useModal()
    const validateVehicles_3 = () => {
        return ownedLeasedFinancedValidator.validateForm(newVehicle, modal)
    }

    // Selected vehicle for deletion
    const removeSelectVehicle = (vehicle, index) => {
        var replaceVehicleClassCopy = replaceVehicleContext.replaceVehicleClass
        replaceVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles.length = 0
        replaceVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles.push(vehicle)
        replaceVehicleContext.setReplaceVehicleClass({ ...replaceVehicleClassCopy })
        storageData.setItem("ReplaceVehicleClass", JSON.stringify(replaceVehicleClassCopy))

        var vehicleCopy = vehicle
        setDeletedVehicle({ ...deleteVehicle, ...vehicleCopy })
    }

    // Retrieves Form Values for Removed Vehicle
    const removeVehCallback = (key, value) => {
        var vehicleCopy = deleteVehicle
        vehicleCopy[key] = value
        setDeletedVehicle({ ...deleteVehicle, ...vehicleCopy });

        if (key == "requestedRemovalEffDate") {
            var vehicleNewCopy = newVehicle
            vehicleNewCopy["requestedCovEffDate"] = value
            setNewVehicle({ ...newVehicle, ...vehicleNewCopy });

            if (replaceVehicleContext.replaceVehicleClass.vehicles.vehiclesOnPolicy.newVehicles?.length > 0) {
                setSessionDataClass("New Vehicle", vehicleNewCopy)
            }
        }
        setSessionDataClass("Remove Vehicle", vehicleCopy)
    }

    // Retrieves Form Values for New Vehicle
    const newVehCallback = (key, value) => {
        var vehicleCopy = newVehicle
        vehicleCopy[key] = value
        setNewVehicle({ ...newVehicle, ...vehicleCopy });

        if (replaceVehicleContext.replaceVehicleClass.vehicles.vehiclesOnPolicy.newVehicles?.length > 0) {
            setSessionDataClass("New Vehicle", vehicleCopy)
        }

        if (key == "requestedCovEffDate") {
            var vehicleRemovedCopy = deleteVehicle
            vehicleRemovedCopy["requestedRemovalEffDate"] = value
            setDeletedVehicle({ ...deleteVehicle, ...vehicleRemovedCopy });
            setSessionDataClass("Remove Vehicle", vehicleRemovedCopy)
        }
    }

    // Sets the class
    const setSessionDataClass = (typeOfVehicle, vehicleCopy) => {
        var replaceVehicleClassCopy = replaceVehicleContext.replaceVehicleClass

        if (typeOfVehicle == "Remove Vehicle") {
            replaceVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0] = vehicleCopy
        }
        else {
            replaceVehicleClassCopy.vehicles.vehiclesOnPolicy.newVehicles[0] = vehicleCopy
        }

        replaceVehicleContext.setReplaceVehicleClass({ ...replaceVehicleClassCopy })
        storageData.setItem("ReplaceVehicleClass", JSON.stringify(replaceVehicleClassCopy))
    }

    return (
        <NewDelete_VehicleContext.Provider
            value={{
                newVehicle, setNewVehicle,
                deleteVehicle, setDeletedVehicle,
                initialVehicle, initialDeleteVehicle,
                removeVehCallback, removeSelectVehicle,
                newVehCallback,
                modal, policyStreetAddress,
                validateVehicles_3
            }}>
            {children}
        </NewDelete_VehicleContext.Provider>
    )
}